import { MDBox, MDSocialButton, MDTypography } from '@components/index';
import { Grid, Link } from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import { sendAmplitudeData } from '@utils/amplitude';
import { CLICKED_SOCIALS } from '@constants/eventNames';


interface FooterProps {
  socials?: boolean;
}

const Footer: React.FC<FooterProps> = ({ socials = true }) => (
    <MDBox
      width='100%'
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      rowGap={0.5}
      mt={1}
      py={1}
      // px={2}
    >
      {socials ? (
        <><MDTypography fontSize='0.875rem' color='dark'>
          Follow for Product Updates
        </MDTypography><MDBox textAlign='center'>
            <Grid
              container
              direction='row'
              spacing={2}
              sx={{ justifyContent: 'center' }}
            >
              <Grid
                item
                onClick={() => sendAmplitudeData(CLICKED_SOCIALS, { social_channel: 'X' })}
              >
                <a
                  href='https://twitter.com/datasquirrel_ai'
                  target='_blank'
                  rel='noreferrer'
                >
                  <MDSocialButton color='twitter' iconOnly size='small'>
                    <TwitterIcon />
                  </MDSocialButton>
                </a>
              </Grid>
              <Grid
                item
                onClick={() => sendAmplitudeData(CLICKED_SOCIALS, { social_channel: 'linkedIn' })}
              >
                <a
                  href='https://www.linkedin.com/company/datasquirrel-ai/'
                  target='_blank'
                  rel='noreferrer'
                >
                  <MDSocialButton color='linkedin' iconOnly size='small'>
                    <LinkedInIcon />
                  </MDSocialButton>
                </a>
              </Grid>
              <Grid
                item
                onClick={() => sendAmplitudeData(CLICKED_SOCIALS, {
                  social_channel: 'instagram'
                })}
              >
                <a
                  href='https://www.instagram.com/datasquirrel.ai'
                  target='_blank'
                  rel='noreferrer'
                >
                  <MDSocialButton
                    iconOnly
                    size='small'
                    sx={{
                      background: 'radial-gradient(circle farthest-corner at 35% 90%, #fec564, transparent 50%), radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%), radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 20% -50%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 60% -20%, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent), linear-gradient(#6559ca, #bc318f 30%, #e33f5f 50%, #f77638 70%, #fec66d 100%)'
                    }}
                  >
                    <InstagramIcon />
                  </MDSocialButton>
                </a>
              </Grid>
              <Grid
                item
                onClick={() => sendAmplitudeData(CLICKED_SOCIALS, { social_channel: 'facebook' })}
              >
                <a
                  href=' https://www.facebook.com/datasquirrel.hq '
                  target='_blank'
                  rel='noreferrer'
                >
                  <MDSocialButton color='facebook' iconOnly size='small'>
                    <FacebookIcon />
                  </MDSocialButton>
                </a>
              </Grid>
            </Grid>
            <a
              href='https://www.datasquirrel.ai/'
              target='_blank'
              rel='noreferrer'
              style={{
                lineHeight: 1,
                textAlign: 'center',
                borderBottom: '1px solid #67748e',
                verticalAlign: 'top'
              }}
            >
              <MDTypography color='info' variant='xs' fontWeight='intermediate'>
                DataSquirrel.ai
              </MDTypography>
            </a>
          </MDBox>
        </>
      ) : (
          <MDTypography
            fontSize='0.875rem'
            component={Link}
            href='https://datasquirrel.ai'
            target='_blank'
            color='dark'
            rel='noreferrer'
            underline>
              Powered by DataSquirrel.ai
            </MDTypography>
      )
      }
    </MDBox>
  );

export default Footer;
